import { type ComponentPropsWithoutRef, type ElementType } from 'react';

import classNames from 'classnames';

import styles from './ShimmerText.module.css';

export type ShimmerTextProps<T extends ElementType = 'div'> = {
  as?: T;
  active?: boolean;
} & Omit<ComponentPropsWithoutRef<T>, 'as'>;

export const ShimmerText = <T extends ElementType = 'div'>({
  as,
  active = true,
  className,
  children,
  ...rest
}: ShimmerTextProps<T>) => {
  const Component = as ?? 'div';
  return (
    <Component
      className={classNames(
        active ? styles.active : styles.inactive,
        className,
      )}
      {...rest}
    >
      {children}
    </Component>
  );
};
